export const toggleDarkMode = (payload: boolean): any => {
    return {
        type: 'TOGGLE_DARK_MODE',
        payload: payload
    }
}